import { updateUser } from 'APIs/AuthApi';
import { useAppSelector } from 'app/hooks';
import { socket } from 'app/socket';
import Footer from 'components/organisms/Footer/DMessageFooter';
import Header from 'components/organisms/Header/DMessageHeader';
import DesktopHeader from 'components/organisms/Header/HomeHeader';
import { addNotification, selectAuth } from 'features/auth/authSlice';
import {
  addOfflineUser,
  selectChat,
  setOnlineUsers,
} from 'features/auth/chatSlice';
import { Notification } from 'interfaces/Notification.interface';
import moment from 'moment';
import { useEffect } from 'react';
import Media from 'react-media';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import DesktopBody from 'views/DesktopViews/DMessage';
import Body from 'views/MobileViews/DMessage';

const DMeesage = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const chatState = useAppSelector(selectChat);
  const authState = useAppSelector(selectAuth);
  useEffect(() => {
    const messageListener = (message: number[]) => {
      if (chatState.onlineUsers.length > 0) {
        chatState.onlineUsers.forEach(async userId => {
          if (!message.includes(userId)) {
            dispatch(addOfflineUser(userId));
            await updateUser({ id: userId, lastOnline: moment().toString() });
          }
        });
      }
      dispatch(setOnlineUsers(message));
    };
    const notificationListener = (notification: Notification) => {
      if (notification.to.id === authState.id)
        dispatch(addNotification(notification));
    };

    socket?.on('message', messageListener);
    socket?.on('notification', notificationListener);

    return () => {
      socket.off('message', messageListener);
      socket.off('notification', notificationListener);
    };
    //eslint-disable-next-line
  }, [socket, authState.id, chatState.onlineUsers]);

  useEffect(() => {
    const send = (userId?: number) => {
      userId && socket?.emit('message', userId);
    };
    const interval = setInterval(() => send(authState.id), 1000 * 10 * 6 * 5);
    return () => {
      clearInterval(interval);
    };
    //eslint-disable-next-line
  }, [authState, socket]);
  return (
    <>
      <Media key={2} query="(max-width: 599px)">
        {matches =>
          matches ? (
            <>
              <Header data={location.state} />
              <Body data={location.state} />
              <Footer data={location.state} />
            </>
          ) : (
            <>
              <DesktopHeader />
              <DesktopBody />
              {/* <DesktopFooter /> */}
            </>
          )
        }
      </Media>
    </>
  );
};

export default DMeesage;
